import type { ReactNode } from 'react';
import { C } from '../../theme/participantTokens';

export function LayerBar({ children }: { children: ReactNode }) {
  return (
    <div
      className="pp-layer-bar"
      style={{
        display: 'flex',
        alignItems: 'center',
        background: C.bgRaised,
        borderBottom: `1px solid ${C.rule}`,
        flexShrink: 0,
        height: 48,
      }}
    >
      {children}
    </div>
  );
}

export function LayerBack({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="pp-layer-back"
      style={{
        height: '100%',
        padding: '0 16px',
        background: 'none',
        border: 'none',
        borderRight: `1px solid ${C.rule}`,
        cursor: 'pointer',
        fontFamily: 'JetBrains Mono',
        fontSize: '0.78rem',
        letterSpacing: '0.16em',
        color: C.textTer,
        textTransform: 'uppercase',
      }}
    >
      ← {label}
    </button>
  );
}

export function SectionEyebrow({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        fontFamily: 'JetBrains Mono',
        fontSize: '0.75rem',
        fontWeight: 500,
        letterSpacing: '0.22em',
        textTransform: 'uppercase',
        color: C.textDim,
        marginBottom: 10,
      }}
    >
      {children}
    </div>
  );
}

export function PageScroll({ children, maxWidth = 860 }: { children: ReactNode; maxWidth?: number }) {
  return (
    <div style={{ flex: 1, overflowY: 'auto' }}>
      <div style={{ padding: '28px 32px 48px', maxWidth }}>{children}</div>
    </div>
  );
}
